import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["cw-choiceOption", { 'showFullScreen': this.showFullScreen, 'use-custom-padding': this.useCustomPadding }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.selectOption && this.selectOption(...args))),
    style: _normalizeStyle({ 'z-index': this.zindex })
  }, _toDisplayString(this.text), 7))
}